import { createFileRoute } from '@tanstack/react-router';

type Search = {
  currentDate?: string;
  appointmentId?: string;
  eventId?: string;
  tab?:
    | 'schedule-appointment-requests-tab'
    | 'schedule-alerts-tab'
    | 'schedule-appointments-list-tab'
    | 'schedule-insurance-tab';
};

/**
 * Route definition for wrapper library
 */
export const Route = createFileRoute('/schedule/calendar')({
  staticData: { team: 'schedule' },
  validateSearch: (search: Search): Search => {
    return {
      eventId: search.eventId || undefined,
      currentDate: search.currentDate || undefined,
      appointmentId: search.appointmentId || undefined,
      tab: search.tab || undefined,
    };
  },
});
